import filterUrlHelper from '../../helpers/filter-url'
import ajax from '../../helpers/ajax'
import i18n from '../../phoenix/translations'

const LocalPointsService = {
  listPoints({options}) {
    const url = `${this.listPointsPath()}${filterUrlHelper.currentStateUrlParamsString(options)}`

    return new Promise((resolve, reject) => {
      ajax.get({
        url,
        successHandler: (response) => {
          resolve(response)
        },
        errorHandler: (err) => {
          reject(err)
        }
      })
    })
  },

  listPointsPath() {
    return '/api/local/points.json'
  },

  listDetailedLocations({options}) {
    const url = `${this.listDetailedLocationsPath()}${filterUrlHelper.currentStateUrlParamsString(options)}`

    const params = {}
    if (window.Agra.Configuration.locationSearchBias.country) {
      params.user_country = window.Agra.Configuration.locationSearchBias.country
    }

    return new Promise((resolve, reject) => {
      ajax.get({
        url,
        params,
        headers: {
          'Accept-Language': i18n.locale()
        },
        successHandler: (response) => {
          resolve(response)
        },
        errorHandler: (err) => {
          reject(err)
        }
      })
    })
  },

  listDetailedLocationsPath() {
    return '/api/local.json'
  },

  getLocationDetails({locations}) {
    return new Promise((resolve, reject) => {
      ajax.post({
        url: this.locationItemsPath(),
        data: {
          identifiers: locations
        },
        successHandler: (response) => {
          resolve(response)
        },
        errorHandler: (err) => {
          reject(err)
        }
      })
    })
  },

  locationItemsPath() {
    return '/api/local/items'
  }
}

export default LocalPointsService
